/**
 *   Generated file. Do not edit
 */

export const ResourceMetaData = {
  '/cloud/platform': {
    put: {
      minApiVersion: 1.0,
      configModeRequired: false,
      schema: {
        $ref: './definitions.yaml#/CloudPlatform',
      },
    },
  },

  '/cloud/data-log/upload-period': {
    put: {
      minApiVersion: 1.0,
      configModeRequired: false,
      schema: {
        type: 'integer',
        format: 'uint32',
      },
    },
  },

  '/cloud/mqtt/broker-port': {
    put: {
      minApiVersion: 1.0,
      configModeRequired: false,
      schema: {
        type: 'string',
        maxLength: 32,
      },
    },
  },

  '/cloud/mqtt/client-id': {
    put: {
      minApiVersion: 1.0,
      configModeRequired: false,
      schema: {
        type: 'string',
        maxLength: 32,
      },
    },
  },

  '/cloud/mqtt/username': {
    put: {
      minApiVersion: 1.0,
      configModeRequired: false,
      schema: {
        type: 'string',
        maxLength: 32,
      },
    },
  },

  '/cloud/mqtt/password': {
    put: {
      minApiVersion: 1.0,
      configModeRequired: false,
      schema: {
        type: 'string',
        maxLength: 32,
      },
    },
  },

  '/cloud/data-log/publish-topic': {
    put: {
      minApiVersion: 1.0,
      configModeRequired: false,
      schema: {
        type: 'string',
        maxLength: 32,
      },
    },
  },

  '/cloud/data-log/subscribe-topic': {
    put: {
      minApiVersion: 1.0,
      configModeRequired: false,
      schema: {
        type: 'string',
        maxLength: 128,
      },
    },
  },
};
